import { FbPopupCellEditorClass } from './FbPopupCellEditorClass';

/**
 * Devuelve la clase FbObjectCellEditor, para que el grid la instancie cuando pinta la celda en modo edición.
 * Esta clase centraliza metodos para usar el popup del grid, renderiza en especial la directiva <fb-grid-popup>
 *
 * @param {FbCellEditor} FbCellEditor se pasa la clase como injección de dependencia
 * @param {Object} options opciones que se pasan de clase en clase (FbObjectCellEditor -> FbCellEditor -> EcCellEditor)
 * @param {Object} methods metodos que se usan para personalizar la celda.
 * @param {function} [methods.isOpened] permite forzar a que el popup este abierto al iniciar la edición
 * @param {function} [methods.renderCell] debe devolver el contenido html visible de la celda, se llama con ({value, data}),
 * @param {function} methods.renderPopup debe devolver el contenido html del popup, se llama con ({value, data})
 * @returns {FbObjectCellEditor}
 */

const defaultOptions = { ecCellName: 'FbObjectCellEditor' };

export function FbObjectCellEditorClass(FbCellEditor, options, { isOpened = false, renderCell, renderPopup } = {}) {
  const FbPopupCellEditor = FbPopupCellEditorClass(FbCellEditor, options, { isOpened, renderCell, renderPopup });

  return class FbObjectCellEditor extends FbPopupCellEditor {
    constructor(currentOptions = {}) {
      super(Object.assign({}, defaultOptions, options, currentOptions));
    }
  };
}
